const componentTypesMap = {
  context_variables: 'context_variables',
  jujo_grid: 'jujo_grid',
  tabs: 'tabs',
  user_panel: 'user_panel',
}
export default componentTypesMap
